import RandomQuotes from './randomquotes/RandomQuotes'
import RandomQuotesIcon from '../assets/icons/random-quotes.png'

import Lycopersicum from './lycopersicum/Lycopersicum'
import LycopersicumIcon from '../assets/icons/lycopersicum.png'

import DrumForFun from './drumforfun/DrumForFun'
import DrumForFunIcon from '../assets/icons/drumforfun.png'

import Calculator from './calculator/Calculator'
import CalculatorIcon from '../assets/icons/calculator.png'

const projectList = [
  {
    path: '/',
    component: RandomQuotes,
    name: 'Random Quotes',
    icon: RandomQuotesIcon,
  },
  {
    path: '/lycopersicum',
    component: Lycopersicum,
    name: 'Lycopersicum',
    icon: LycopersicumIcon,
  },
  {
    path: '/drumforfun',
    component: DrumForFun,
    name: 'Drum for Fun',
    icon: DrumForFunIcon,
  },
  {
    path: '/calculator',
    component: Calculator,
    name: 'Simple Calculator',
    icon: CalculatorIcon,
  }
]

export default projectList